<template>
	<v-select
    :label="$attrs.label || 'Potência'"
		:items="itens"
		:loading="carregando || $attrs.loading"
		item-text="nome"
		item-value="_id"
		v-bind="$attrs"
		:value="value"
		v-on="$listeners"
		@click:clear="() => $nextTick(() => $emit('input', null))"
	/>
</template>

<script setup lang="ts">
import { PropType, ref } from 'vue'
import { getErrorMessage } from '@/helpers/error-helpers'
import { Potencia } from 'common/types/Potencia'
import PotenciaService from '../services/PotenciaService'

defineProps({
	value: {
		default: null,
		type: [Object, String, Array] as PropType<{
			value: string
			text: string,
		} | null | string>,
	},
})

defineEmits<{
	(e: 'input', valor: null): void
}>()

const carregando = ref(true)
const erro = ref('')
const itens = ref<Potencia[]>([])

async function carregarPotencias() {
	carregando.value = true
	try {
		itens.value = await PotenciaService.find()
	} catch (e) {
		erro.value = getErrorMessage(e)
	} finally {
		carregando.value = false
	}
}

carregarPotencias()
</script>
